// 常见接地类型模板与阻抗近似（工程近似，按母线电压不缩放）
export const GROUNDING_OPTIONS = [
  { value: 'solid', label: '实心接地 (Solid)' },
  { value: 'resistor', label: '经电阻接地 (Resistor)' },
  { value: 'reactor', label: '经电抗接地 (Reactor)' },
  { value: 'arc_suppression_coil', label: '消弧线圈 (Arc Suppression Coil)' },
  { value: 'none', label: '不接地 (None)' }
];

// 近似阻抗映射，可根据母线电压/系统规模进一步细化
export function resolveGroundingImpedance(type, ctx = {}) {
  switch ((type || '').toLowerCase()) {
    case 'solid':
      return { R_ohm: 0, X_ohm: 0 };
    case 'resistor':
      return { R_ohm: 1.0, X_ohm: 0 };
    case 'reactor':
      return { R_ohm: 0, X_ohm: 1.5 };
    case 'arc_suppression_coil':
      return { R_ohm: 0, X_ohm: 5.0 };
    case 'none':
      return { R_ohm: 1e6, X_ohm: 1e6 };
    default:
      return { R_ohm: 0.5, X_ohm: 0 };
  }
}